"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CardActions_1 = __importDefault(require("@material-ui/core/CardActions"));
var CardActions = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.disableSpacing, disableSpacing = _b === void 0 ? false : _b;
    return (react_1.default.createElement(CardActions_1.default, { classes: classes, disableSpacing: disableSpacing }, children));
};
exports.default = CardActions;
